import View from "../common/views/HeaderAisleView";
import components from "./components.js";
components.define("js-Header__search-dropdown", View);